module.exports = __webpack_public_path__ + "img/paper.1f47baad.svg";